import {
  formatEquifaxApplicantScoreBanner,
  hasEquifaxApplicantScoreBannerContext,
} from "../../utils/creditReportHelpers";
import type { CreditReportEquifaxBannerProps } from "../../types";

export function CreditReportEquifaxBanner({ tab }: CreditReportEquifaxBannerProps) {
  const { applicationData } = tab;

  if (
    !hasEquifaxApplicantScoreBannerContext(
      applicationData as Record<string, unknown> | null | undefined,
    )
  ) {
    return null;
  }

  return (
    <div className="mt-8 border-b border-slate-200/80 pb-4" data-testid="application-credit-report-tab-section-equifax-score">
      <h2
        className="m-0 text-lg font-semibold sm:text-xl"
        style={{ color: "#1597ff" }}
      >
        Applicant Score :{" "}
        {formatEquifaxApplicantScoreBanner(
          applicationData as Record<string, unknown> | null | undefined,
        )}
      </h2>
    </div>
  );
}
